// This must be the first line in src/index.js
// siehe: https://github.com/facebook/create-react-app/blob/master/packages/react-app-polyfill/README.md
import "react-app-polyfill/ie9";

import React from "react";
import ReactDOM from "react-dom";

import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import { Provider, intlReducer } from "react-intl-redux";

import { ConnectedRouter, routerReducer, routerMiddleware } from "react-router-redux";
import createHistory from "history/createBrowserHistory";

import createSagaMiddleware from "redux-saga";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap-theme.css";
// Put any other imports below so that CSS from your
// components takes precedence over default styles.
import "rc-slider/assets/index.css";
import "react-day-picker/lib/style.css";

import io from "socket.io-client";

/* *******************************
 * ab hier die Importe vom Projekt
 * (wegen CSS)
 * *******************************/

import App from "./App";
import "./tabellen/Tabellen.css";

import { ablaufReducer, ablaufChangedAction, ablaufSnapshotAction,
	ablaufResetAction } from "./model/Ablauf";
import { rtcAction, rtcReducer } from "./model/Rtc";
import { dataLogReducer, dataLogMiddleware } from "./model/Datenlog";
import { chartsReducer, chartsMiddleware } from "./model/Diagramme";
import { thinkGreenReducer } from "./model/Think_Green";
import { errorLogReducer } from "./model/Fehlerspeicher";
import { settingsReducer, acceptNewSettings } from "./model/Settings";
import { userReducer } from "./model/Benutzer";
import { fehlertextReducer, fehlertextReceivedAction,
	fehlertextResetAction } from "./model/Fehlertexte";
import { fetchHeDataLogsListReducer } from "./model/HeDataLogs"

import { unitsReducer } from "./einheiten/Units";
import { defaultLocale, localeReducer } from "./lng/Locales";

import { rootSaga } from './model/sagas/sagas'

import registerServiceWorker from "./registerServiceWorker";

// Create a history of your choosing (we're using a browser history in this case)
const history = createHistory();

// Build the middleware for intercepting and dispatching navigation actions
const router_middleware = routerMiddleware(history);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : compose;

const initial_state = {
	intl: defaultLocale
};

const sagaMiddleware = createSagaMiddleware();

const store = createStore(
	combineReducers({
		ablauf: ablaufReducer,
		data_log: dataLogReducer,
		he_data_log_files: fetchHeDataLogsListReducer,
		charts: chartsReducer,
		think_green: thinkGreenReducer,
		error_log: errorLogReducer,
		fehlertexte: fehlertextReducer,
		settings: settingsReducer,
		user: userReducer,
		rtc: rtcReducer,
		units: unitsReducer,
		intl: intlReducer,
		// Anzeige aktuelle Sprache in der Kopfzeile
		current_locale_i18n_key: localeReducer,
		/* react-router-redux@5 -> Add the reducer to your store on the
		 * `router` key
		 */
		router: routerReducer
	}),
	initial_state,
	composeEnhancers(
		// react-router-redux@5 -> Also apply our middleware for navigating
		applyMiddleware(router_middleware, dataLogMiddleware, chartsMiddleware, sagaMiddleware)
	)
);
sagaMiddleware.run(rootSaga);

const socket = io.connect();
socket.on("rtc", date => {
	store.dispatch(rtcAction(date));
});
socket.on("ablauf_snapshot", snapshot => {
	store.dispatch(ablaufSnapshotAction(snapshot));
});
socket.on("ablauf_change", change => {
	store.dispatch(ablaufChangedAction(change));
});
socket.on("ablauf_fehlertext", fehlertext => {
	store.dispatch(fehlertextReceivedAction(fehlertext));
});
socket.on("ablauf_disconnected", () => {
	store.dispatch(fehlertextResetAction());
	store.dispatch(ablaufResetAction());
});
socket.on("settings", settings => acceptNewSettings(settings, store.dispatch));

export const emitToServer = (type, data) => socket.emit(type, data);

ReactDOM.render(
	<Provider store={store}>
		{ /* react-router-redux@5 -> ConnectedRouter will use the store
		   * from Provider automatically */ }
		<ConnectedRouter history={history}>
			{/* Hier darf kein von redux-connect() erzeugtes Element stehen? */}
			<App />
		</ConnectedRouter>
	</Provider>,
	document.getElementById("root")
);
registerServiceWorker();	// stört das Ding hier???
